class LocalizationPopup extends HTMLElement {
  connectedCallback() {
    this.checkOpen();
  }

  checkOpen = () => {
    if(this.dataset.open != undefined && localStorage.getItem('localization-popup') === null && window.location.pathname !== '/') {
      this.open();
    }
  }

  open = () => {
    this.classList.add('open');
    if(this.dataset.open != undefined) {
      localStorage.setItem('localization-popup', 'true');
    }
  }

  close = () => {
    this.classList.remove('open');
  }
}
if (!customElements.get('localization-popup')) {
  customElements.define('localization-popup', LocalizationPopup);
}

//se per testare si vuole far "dimenticare" al browser che l'utente ha già visto il popup, scrivi nella console del browser: localStorage.removeItem('localization-popup'); e premi invio


class LocalizationOpener extends HTMLElement {

  connectedCallback() {
    this.addEventListener('click', this.openPopup.bind(this));
  }

  openPopup = () => {
    const popup = document.querySelector('localization-popup');
    if(popup != undefined)
      popup.open();
  }

}
if (!customElements.get('localization-opener')) {
  customElements.define('localization-opener', LocalizationOpener);
}